<template>
  <v-alert :value="true">
    <v-layout>
      <v-flex>
        <p
          v-if="warn"
          class="mb-0 f-1"
        >
          {{ warnText || $t('description.warn') }}
        </p>
        <p class="mb-0 f-1">
          {{ text }}
        </p>
      </v-flex>
    </v-layout>
  </v-alert>
</template>

<script>
export default {
    name: 'InfoAlert',
    props: {
        text: {
            required: true
        },
        warn: {
            default: true,
            type: Boolean
        },
        warnText: {
            type: String,
            default: ''
        }
    }
};
</script>

<style scoped></style>
